// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentSetup_root__Nxzxd {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
  color: var(--color-font-10);
  font-size: 16px !important;
}

.PaymentSetup_account_title__HtvA1 {
  display: flex;
  align-items: center;
}

.PaymentSetup_business_icon__6FBIC {
  padding-right: 10px;
}

.PaymentSetup_arrow_icon__FXd\\+7 {
  padding: 0px 20px;
  color: var(--color-theme-silver);
}

.PaymentSetup_account_title__HtvA1 {
  display: flex;
  align-items: center;
}

.PaymentSetup_business_icon__6FBIC {
  padding-right: 10px;
}

.PaymentSetup_stripe_container__OGoo3 {
  display: flex;
  align-items: flex-start;
  margin-top: 40px;
}

.PaymentSetup_text_container__ga3OZ {
  width: 50%;
  margin: 30px 0 0 40px;
}

.PaymentSetup_logo_container__MzHPp {
  width: 20%;
}

.PaymentSetup_confirm_btn__NtzWO {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
  margin-top: 30px !important;
}

.PaymentSetup_confirm_btn__NtzWO a {
  text-decoration: none;
  color: var(--color-theme-blue);
}

.PaymentSetup_confirm_btn__NtzWO:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}

.PaymentSetup_confirm_btn__NtzWO:hover a {
  color: var(--color-theme-white) !important;
}

.PaymentSetup_connected_account__fDRhs {
  display: flex;
  align-items: center;
  color: var(--color-theme-green);
  padding: 20px 0px;
  font-weight: bold;
}

.PaymentSetup_connected_account__fDRhs p {
  font-size: 22px !important;
}

.PaymentSetup_check_circle_icon__R00bq {
  margin-right: 10px;
}

.PaymentSetup_stripe_logo__GhQSr {
  width: 250px;
  height: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/PaymentSetup/PaymentSetup.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n  color: var(--color-font-10);\n  font-size: 16px !important;\n}\n\n.account_title {\n  display: flex;\n  align-items: center;\n}\n\n.business_icon {\n  padding-right: 10px;\n}\n\n.arrow_icon {\n  padding: 0px 20px;\n  color: var(--color-theme-silver);\n}\n\n.account_title {\n  display: flex;\n  align-items: center;\n}\n\n.business_icon {\n  padding-right: 10px;\n}\n\n.stripe_container {\n  display: flex;\n  align-items: flex-start;\n  margin-top: 40px;\n}\n\n.text_container {\n  width: 50%;\n  margin: 30px 0 0 40px;\n}\n\n.logo_container {\n  width: 20%;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n  margin-top: 30px !important;\n}\n\n.confirm_btn a {\n  text-decoration: none;\n  color: var(--color-theme-blue);\n}\n\n.confirm_btn:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n\n.confirm_btn:hover a {\n  color: var(--color-theme-white) !important;\n}\n\n.connected_account {\n  display: flex;\n  align-items: center;\n  color: var(--color-theme-green);\n  padding: 20px 0px;\n  font-weight: bold;\n}\n\n.connected_account p {\n  font-size: 22px !important;\n}\n\n.check_circle_icon {\n  margin-right: 10px;\n}\n\n.stripe_logo {\n  width: 250px;\n  height: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PaymentSetup_root__Nxzxd`,
	"account_title": `PaymentSetup_account_title__HtvA1`,
	"business_icon": `PaymentSetup_business_icon__6FBIC`,
	"arrow_icon": `PaymentSetup_arrow_icon__FXd+7`,
	"stripe_container": `PaymentSetup_stripe_container__OGoo3`,
	"text_container": `PaymentSetup_text_container__ga3OZ`,
	"logo_container": `PaymentSetup_logo_container__MzHPp`,
	"confirm_btn": `PaymentSetup_confirm_btn__NtzWO`,
	"connected_account": `PaymentSetup_connected_account__fDRhs`,
	"check_circle_icon": `PaymentSetup_check_circle_icon__R00bq`,
	"stripe_logo": `PaymentSetup_stripe_logo__GhQSr`
};
export default ___CSS_LOADER_EXPORT___;
